module.exports = __webpack_public_path__ + "static/fipcbluepanda2-54fec01df539827c11ef14d178298258.jpeg";